
<template>
  <div>
    <v-layout fluid fill-height mt-0 pt-0>
      <v-btn @click="toggleMapType()" class="map-floating-button">
        {{ mapTypeToggleLabel }}
      </v-btn>
      <gmap-map
        class="map"
        :center="mapCenter || {lat:0, lng:0}"
        :zoom=3.75
        :map-type-id="mapType"
        style="width: 100%; height: 100%; margin: 0px; padding: 0px"
        v-bind:options="mapStyle"
        @zoom_changed="zoomChanged"
        @center_changed="centerChanged"
        ref="map"
      >
        <gmap-marker
          v-for="(m, idx) in nodes"
          v-if="typeof m != 'undefined'"
          :key="`node:${idx}`"
          :icon="nodeIcons[m.type]"
          :title="m.name"
          :position="m.position"
          :draggable="false"
          :clickable="true"
        />
        <gmap-polyline
          v-for="(lane, idx) in lanes"
          :key="`lane:${idx}`"
          :title="lane.name"
          :path="[ lane.from.position, lane.to.position ]"
          :options="{ strokeWeight: 1.25, strokeColor: '#808080', geodesic: true, icons: lineStyleForFlow(lane.flow) }"
          :clickable="true"
        />

      </gmap-map>

      <!--<a href="https://starboardcorp.com" target="_blank">
        <img class="watermark" src='@/assets/starboard-logo.png' />
      </a>-->
    </v-layout>
  </div>
</template>

<script>
import googleMapStyles from '@/assets/map.json'
import {gmapApi} from 'vue2-google-maps'
import _ from 'lodash'

export default {
  name: 'starboard-network-visualizer',
  data () {
    return {
      nodeIcons: {
        customer: window.location.origin+'/icon_customer050.png',
        warehouse: window.location.origin+'/icon_warehouse.png',
        port: window.location.origin+'/icon_port.png',
        plant: window.location.origin+'/icon_plant.png'
      },

      mapStyle: {
        zoomControl: false,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        styles: googleMapStyles 
      },
      mapType: "roadmap",
      center: Object,
      centerChanging: Object
    }
  },

  props: {
    mapCenter: Object,
    nodes: Array,
    lanes: Array
  },

  mounted() {
    this.$refs.map.$mapPromise
      .then(map => {
        map.setZoom(4)
        map.setCenter((this.mapCenter || {lat:38.768403, lng:-96.0}))
        // from https://stackoverflow.com/questions/9577034/google-maps-scroll-map-programmatically-of-x-pixels
        let overlay = new this.google.maps.OverlayView()
        overlay.draw = function(){}
        overlay.setMap(map)
      })
  },

  methods: {
    lineStyleForFlow: function(flow) {
      return flow > 0 ? [] : [{
        icon: {
          path: 'M0, -1 0, 1',
          strokeOpacity: 1.0,
          strokeColor: "#ffffff",
          strokeWeight: 1.25,
          scale: 4,
        },
        offset: 0,
        repeat: '20px'
      }]
    },
    zoomChanged: function(zoomLevel){
      this.$emit('zoom-changed', zoomLevel)
    },
    centerChanged: function(center){
      this.center = center
      if(this.centerChanging) {
        clearTimeout(this.centerChanging)
      }
      this.centerChanging = setTimeout(this.updateCenter, 500)
    },
    updateCenter: async function(){
      this.$emit('center-changed', {lat: this.center.lat(), lng: this.center.lng()})
    },
    toggleMapType: function() {
      this.mapType = this.mapType == "roadmap" ? "hybrid" : "roadmap"
    }
  },

  computed: {
    google: gmapApi,
    mapTypeToggleLabel() {
      return this.mapType == "roadmap" ? "Satellite" : "Roadmap"
    }
  }
}

</script>


<style scoped>
.watermark {
  width: 47px;
  height: 54px;
  position: absolute;
  bottom: 35px;
  right: 15px;
  opacity: 0.5;
}
.map {
  width:100%;
  height: 100%;
}
.map-floating-button {
  position: absolute;
  top: 40px;
  right: 10px;
  z-index: 10;
}
</style>